import { createSlice } from '@reduxjs/toolkit'
import {
  archiveCourse,
  assignBranchToCourse,
  createCourseContentModules,
  createCourseFees,
  createCourseInformation,
  deleteModulesAndTopics,
  deleteUploadedDocument,
  editCourseContent,
  editCourseInformation,
  getBatchList,
  getBranchList,
  getCourse,
  getCourseByCourseId,
  getCourseMaterials,
  getCoursePricing,
  getCourseBranchFees,
  getCourseListByBranchId,
  getCourseListWithDraftByBranchId,
} from '../../builders/course/course.builder'

const initialState = {
  courseId: '',
  materials: [],
  courseInformation: {},
  loading: false,
  course: [],
  courseContent: {},
  branchList: [],
  batchList: [],
  courseFees: [],
  currentCourse: {},
  branchCourseFees: [],
  CourseListByBranchId: [],
  CourseListByDraftBranchId: [],
  courseContentLoading: false,
  videoData: '',
}

const courseSlice = createSlice({
  name: 'course',
  initialState,
  reducers: {
    setCourseInformation(state, action) {
      state.courseInformation = { ...action.payload }
    },
    resetCourseState(state) {
      state.courseId = null
      state.materials = []
      state.courseInformation = {}
      state.courseContent = {}
      state.branchList = []
      state.batchList = []
      state.courseFees = []
      state.course = []
      state.currentCourse = {}
      state.branchCourseFees = []
      state.CourseListByBranchId = []
      state.courseContentLoading = false
    },
    setCourseContent(state, action) {
      state.courseContent = { ...action.payload }
    },
    clearExtraReducers: (state) => {
      state.loading = true
      state.courseId = null
      state.materials = []
      state.courseInformation = {}
      state.course = []
      state.courseContent = {}
      state.branchList = []
      state.batchList = []
      state.courseFees = []
      state.course = []
      state.currentCourse = {}
      state.branchCourseFees = []
      state.CourseListByBranchId = []
      state.CourseListByDraftBranchId = []
      state.courseContentLoading = false
    },
    resetCourseFees: (state) => {
      state.courseFees = []
    },
    setLoading(state, action) {
      state.courseContentLoading = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getCourse.pending, (state) => {
      state.loading = true
      state.course = []
    })
    builder.addCase(getCourse.fulfilled, (state, action) => {
      state.loading = false
      state.course = action.payload
    })
    builder.addCase(getCourse.rejected, (state) => {
      state.loading = false
    })
    builder.addCase(getCourseMaterials.pending, (state) => {
      state.loading = true
    })
    builder.addCase(getCourseMaterials.fulfilled, (state, action) => {
      state.loading = false
      state.materials = [...action.payload]
    })
    builder.addCase(getCourseMaterials.rejected, (state) => {
      state.loading = false
    })
    builder.addCase(createCourseInformation.pending, (state) => {
      state.loading = true
    })
    builder.addCase(createCourseInformation.fulfilled, (state, action) => {
      state.loading = false
      state.courseId = action.payload
    })
    builder.addCase(createCourseInformation.rejected, (state) => {
      state.loading = false
    })
    builder.addCase(getBranchList.pending, (state) => {
      state.loading = true
    })
    builder.addCase(getBranchList.fulfilled, (state, action) => {
      state.loading = false
      state.branchList = [...action.payload]
    })
    builder.addCase(getBranchList.rejected, (state) => {
      state.loading = false
    })
    builder.addCase(getBatchList.pending, (state) => {
      state.loading = true
    })
    builder.addCase(getBatchList.fulfilled, (state, action) => {
      state.loading = false
      state.batchList = [...action.payload]
    })
    builder.addCase(getBatchList.rejected, (state) => {
      state.loading = false
    })
    builder.addCase(createCourseFees.pending, (state) => {
      state.loading = true
    })
    builder.addCase(createCourseFees.fulfilled, (state, action) => {
      state.loading = false
      state.courseFees = [...action.payload]
    })
    builder.addCase(createCourseFees.rejected, (state) => {
      state.loading = false
    })
    builder.addCase(getCourseByCourseId.pending, (state) => {
      state.loading = true
    })
    builder.addCase(getCourseByCourseId.fulfilled, (state, action) => {
      state.loading = false
      state.currentCourse = action.payload[0]
    })
    builder.addCase(getCourseByCourseId.rejected, (state) => {
      state.loading = false
    })
    builder.addCase(getCoursePricing.pending, (state) => {
      state.loading = true
    })
    builder.addCase(getCoursePricing.fulfilled, (state, action) => {
      state.loading = false
      state.courseFees = [...action.payload]
    })
    builder.addCase(getCoursePricing.rejected, (state) => {
      state.loading = false
    })
    builder.addCase(editCourseInformation.pending, (state) => {
      state.loading = true
    })
    builder.addCase(editCourseInformation.fulfilled, (state) => {
      state.loading = false
    })
    builder.addCase(editCourseInformation.rejected, (state) => {
      state.loading = false
    })
    builder.addCase(createCourseContentModules.pending, (state) => {
      state.loading = true
    })
    builder.addCase(createCourseContentModules.fulfilled, (state) => {
      state.loading = false
    })
    builder.addCase(createCourseContentModules.rejected, (state) => {
      state.loading = false
    })
    builder.addCase(editCourseContent.pending, (state) => {
      state.loading = true
    })
    builder.addCase(editCourseContent.fulfilled, (state) => {
      state.loading = false
    })
    builder.addCase(editCourseContent.rejected, (state) => {
      state.loading = false
    })
    builder.addCase(deleteModulesAndTopics.pending, (state) => {
      state.loading = true
    })
    builder.addCase(deleteModulesAndTopics.fulfilled, (state) => {
      state.loading = false
    })
    builder.addCase(deleteModulesAndTopics.rejected, (state) => {
      state.loading = false
    })
    builder.addCase(assignBranchToCourse.pending, (state) => {
      state.loading = true
    })
    builder.addCase(assignBranchToCourse.fulfilled, (state) => {
      state.loading = false
    })
    builder.addCase(assignBranchToCourse.rejected, (state) => {
      state.loading = false
    })
    builder.addCase(archiveCourse.pending, (state) => {
      state.loading = true
    })
    builder.addCase(archiveCourse.fulfilled, (state) => {
      state.loading = false
    })
    builder.addCase(archiveCourse.rejected, (state) => {
      state.loading = false
    })
    builder.addCase(deleteUploadedDocument.pending, (state) => {
      state.loading = true
    })
    builder.addCase(deleteUploadedDocument.fulfilled, (state) => {
      state.loading = false
    })
    builder.addCase(deleteUploadedDocument.rejected, (state) => {
      state.loading = false
    })
    builder.addCase(getCourseBranchFees.pending, (state) => {
      state.loading = true
    })
    builder.addCase(getCourseBranchFees.fulfilled, (state, action) => {
      state.loading = false
      state.branchCourseFees = action.payload
    })
    builder.addCase(getCourseBranchFees.rejected, (state) => {
      state.loading = false
    })
    builder.addCase(getCourseListByBranchId.pending, (state) => {
      state.loading = true
      state.CourseListByBranchId = []
    })
    builder.addCase(getCourseListByBranchId.fulfilled, (state, action) => {
      state.loading = false
      state.CourseListByBranchId = action.payload
    })
    builder.addCase(getCourseListByBranchId.rejected, (state) => {
      state.loading = false
    })
    builder.addCase(getCourseListWithDraftByBranchId.pending, (state) => {
      state.loading = true
      state.CourseListByBranchId = []
    })
    builder.addCase(getCourseListWithDraftByBranchId.fulfilled, (state, action) => {
      state.loading = false
      state.CourseListByDraftBranchId = action.payload
    })
    builder.addCase(getCourseListWithDraftByBranchId.rejected, (state) => {
      state.loading = false
    })
  },
})

// const initialState = {
//     isCourseInformationFilled: false,
//     isCourseInformationNextClicked: true,
//     loading: false,
//     course: [],
//     module: [],
//     topic: [],
//     courseData: []
// };

// const courseSlice = createSlice({
//     name: "course",
//     initialState,
//     reducers: {
//        clearExtraReducers : (state) => {
//             state.loading = true,
//             state.course = [],
//             state.module = [],
//             state.topic = [],
//             state.courseData = []
//         }
//     },
//     extraReducers: (builder) => {
//         builder.addCase(getCourse.pending, (state, action)=>{
//             state.loading = true,
//             state.course = []

//         }),
//         builder.addCase(getCourse.fulfilled, (state, action)=>{
//             state.loading = false
//             state.course = action.payload
//         }),
//         builder.addCase(getCourse.rejected, (state, action)=>{
//             state.loading = false

//         }),
//         builder.addCase(createCourse.pending, (state, action)=>{
//             state.loading = true,
//             state.courseData = []

//         }),
//         builder.addCase(createCourse.fulfilled, (state, action)=>{
//             state.loading = false
//             state.courseData = action.payload
//         }),
//         builder.addCase(createCourse.rejected, (state, action)=>{
//             state.loading = false
//         })
//         builder.addCase(createCourseModule.pending, (state, action)=>{
//             state.loading = true,
//             state.module = []

//         }),
//         builder.addCase(createCourseModule.fulfilled, (state, action)=>{
//             state.loading = false
//             state.module = action.payload
//         }),
//         builder.addCase(createCourseModule.rejected, (state, action)=>{
//             state.loading = false
//         }),
//         builder.addCase(createCourseModuleTopic.pending, (state, action)=>{
//             state.loading = true,
//             state.topic = []

//         }),
//         builder.addCase(createCourseModuleTopic.fulfilled, (state, action)=>{
//             state.loading = false
//             state.topic = action.payload
//         }),
//         builder.addCase(createCourseModuleTopic.rejected, (state, action)=>{
//             state.loading = false
//         })
//     }

// })

export const {
  setCourseInformation,
  resetCourseState,
  setCourseContent,
  resetCourseFees,
  clearExtraReducers,
  setLoading,
} = courseSlice.actions

export default courseSlice.reducer
